import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import SectorSelector from '../common/select-filters/SectorSelector.js';
import WorkAccidentsChart from '../common/charts/WorkAccidentsChart';
import WorkAccidentsSectorChart from '../common/charts/WorkAccidentsSectorChart.js';
import Related from '../common/Related.js';
import Methodology from '../common/Methodology';

import { largeSize, mediumSize } from '../common/utils/chartConfig';

import { workAccidents } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

// Contries Exceptions
import { workAccidentsExceptions } from '../../model/countriesExceptions';

const WorkAccidents = props => {

	const currentPath = '/accidents-diseases-well-being/work-accidents/';

	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry);
	const [isLoading, setIsLoading] = useState(true);
	const [selectedTab, setSelectedTab] = useState(null);
	const [secondLevelTabs, setSecondLevelTabs] = useState([]);
	const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(null);
	const [sector1, setSector1] = useState(null);
	const [sector2, setSector2] = useState(null);
	const [sector3, setSector3] = useState(null);
	
	// Hook for the dispatchs
	const dispatch = useDispatch();

	useEffect(() => {
		const lockedExceptions = workAccidentsExceptions.find((element) => props.lockedCountry == element.code);		
		const localExceptions = workAccidentsExceptions.find((element) => props.selectCountry == element.code);

		let selected = '', secondLevel = '', secondLevelSelected;
		selected = workAccidents.find((tab) => tab.url == props.firstLevel);
		if (selected == undefined)
		{
			selected = workAccidents[0]
		}

		setSelectedTab(selected);

		if (selected.subTabs != undefined)
		{
			secondLevel = selected.subTabs;

			secondLevelSelected = secondLevel.find((tab) => tab.url == props.indicator);

			if (secondLevelSelected == null)
			{
				secondLevelSelected = secondLevel[0];
			}

			setSecondLevelTabs(secondLevel);
			setSecondLevelSelectedTab(secondLevelSelected);
		}

		// Update the title of the page
		document.title = props.literals.L22010 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		if (!selectedByUser) {
			if (props.country1 != undefined && props.country1 != '') {
				dispatch(setCountry1(props.country1))
			}
		}

		if (props.country2 != undefined && props.country2 != '') {
			dispatch(setCountry2(props.country2))
		}

		if (props.country3 != undefined && props.country3 != '') {
			dispatch(setCountry3(props.country3))
		}

		setIsLoading(false);

	}, [])

	const handleSearch = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1)
		} else {
			dispatch(setCountry1(callbackCountry1))
		}
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
	}

	const handleSector1Change = (callbackSector1) => {
		setSector1(callbackSector1);
	}

	const handleSector2Change = (callbackSector2) => {
		setSector2(callbackSector2);
	}

	const handleSector3Change = (callbackSector3) => {
		setSector3(callbackSector3);
	}

	const callbackSelectedTab = (callback) => {
		let selected = workAccidents.find((tab) => tab.url == callback);
		if (selected == null)
		{
			selected = workAccidents[0];
		}

		setSelectedTab(selected);

		let secondLevel = selected.subTabs;
		setSecondLevelTabs(secondLevel);

		if (secondLevel != undefined && secondLevel.length > 0)
		{
			setSecondLevelSelectedTab(secondLevel[0]);
		}
		else
		{
			setSecondLevelSelectedTab(null);
		}
	}

	const callbackSelectedIndicator = (callback) => {
		// Get the data for the tab that has the same URL as the one selected
		let secondLevelSelected = secondLevelTabs.find((tab) => callback == tab.url);
		if (secondLevelSelected == undefined)
		{
			secondLevelSelected = secondLevelTabs[0];
		}

		// Set that tab as the one selected
		setSecondLevelSelectedTab(secondLevelSelected);
	}

	if (!isLoading)
	{
		let indicatorID;
		let chart = null;

		let activeTab = selectedTab;
		if (secondLevelSelectedTab != null)
		{
			activeTab = secondLevelSelectedTab;
		}

		let tabChart = activeTab.chart;
		let colors = ['#f6a400','#cbe2e3','#7b7b7d'];
		if (activeTab.showCountrySelect)
		{
			colors = ['#f6a400','#529FA2','#7b7b7d'];
		}

		let size = mediumSize;
		if (tabChart.size == "large")
		{
			size = largeSize
		}

		indicatorID = tabChart.indicator;
			
		chart = activeTab.sectorChart === true ? 
			<WorkAccidentsSectorChart 
				title={ props.literals[`L${tabChart.title}`] }
				chart={ tabChart }
				sector1={ sector1 }
				sector2={ sector2 }
				sector3={ sector3 }
				selectedCountry1={ selectedByUser ? countryLocked : selectCountry }
				selectedCountry2={ selectCountry2 }
				selectedCountry3={ selectCountry3 }
				showDataFor = { activeTab.showCountrySelect === true ? 'country' : 'sector' }
				colors = { colors }
				fullCountryReport = { false }
				percentage={ tabChart.percentage }
			/>
		
			: <WorkAccidentsChart 
				title={ props.literals[`L${tabChart.title}`] }
				showDataLabel={ true }
				percentage={ tabChart.percentage }
				type={ tabChart.type }
				chart={ tabChart.id }
				indicator={ tabChart.indicator }
				selectedCountry1={ activeTab.showCountrySelect ? selectedByUser ? countryLocked : selectCountry : null }
				selectedCountry2={ activeTab.showCountrySelect ? selectCountry2 : null }
				selectedCountry3={ activeTab.showCountrySelect ? selectCountry3 : null }
				colors={ colors }
				chartSize={ size }
			/>


		return(
			<div className="work-accidents">
				<AdviceSection literals={ props.literals } section={["accidents-diseases-well-being","work-accidents"]} methodologyData={{section: 'accidents-diseases-well-being', subsection: 'Work accidents', indicator: 53}} />
				<form className="compare--block--form">
					<SubMenuTabs 
						literals={ props.literals }
						selectedTab={ selectedTab.url }
						callbackSelectedTab={ callbackSelectedTab }
						locationPath={ currentPath }
						subMenuTabs={ workAccidents } 
					/>

					<div className="line background-main-light" />

					{ ( secondLevelTabs ) && (
						<React.Fragment>							
							<SubMenuTabs 
								literals={ props.literals }
								selectedTab={ secondLevelSelectedTab.url }
								callbackSelectedTab={ callbackSelectedIndicator }
								locationPath={ `${currentPath}${selectedTab.url}/` }
								subMenuTabs={ secondLevelTabs } 
								selectCountry1={ selectedByUser ? countryLocked : selectCountry }
								selectCountry2={ selectCountry2}
								selectCountry3={ selectCountry3}
							/>

							<div className="line background-main-light" />
						</React.Fragment>
					)}

					{ activeTab.showCountrySelect && (
						<React.Fragment>
							<SelectEconomic 
								handleSearch={ handleSearch } 
								handleSearch2={ handleSearch2 } 
								handleSearch3={ handleSearch3 }
								charts={ [ tabChart.id ] }
								indicator={ tabChart.indicator }
								literals={ props.literals }
								selectedCountry1={ selectedByUser ? countryLocked : selectCountry }
								selectedCountry2={ selectCountry2 }
								selectedCountry3={ selectCountry3 }
							/>
							
							<div className="line background-main-light" />
						</React.Fragment>
					)}

					{ activeTab.showSectorSelect && (
						<React.Fragment>
							<SectorSelector 
								indicator="579"
								literals={ props.literals }
								handleSector1Change = { handleSector1Change }
								handleSector2Change = { handleSector2Change }
								handleSector3Change = { handleSector3Change }
							/>
							
							<div className="line background-main-light" />
						</React.Fragment>
					)}

					<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
						<div className="card--block--chart no-filters">
							<div className="chart--block">
								{ chart }
							</div>
						</div>

						<div className="chart-legend">
							{ ReactHtmlParser( props.literals[`L${tabChart.legend}`]) }
						</div>
					</div>

				</form>
				<Methodology literals={ props.literals } section={'Work accidents'} indicator={ indicatorID } />

				{ selectedTab.url != 'serious-non-fatal-work-accidents' && (
					<Related literals={ props.literals } section={["accidents-diseases-well-being","work-accidents", props.indicator ]} />
				)}
				
		</div>
		)
	}
	else
	{
		return null;
	}
}

WorkAccidents.displayName = 'WorkAccidents';

export default WorkAccidents;